export { default } from './component';
export { useCardMedia } from './hook';